module.exports = __webpack_public_path__ + "static/media/clumberland.a0ef7e23.svg";